import { Injectable, NgZone } from '@angular/core';
import { AppConfig } from '../../../../environments/environment';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {

  private _ready = false;

  constructor(private ngZone: NgZone) {
    this.init();
  }

  private init(): void {
    if (typeof AppConfig.postHogConfig === 'undefined' || !AppConfig.postHogConfig.enabled) return;

    this.ngZone.runOutsideAngular(() => {
      posthog.init(AppConfig.postHogConfig.key, {
        api_host: AppConfig.postHogConfig.host,
        defaults: '2026-01-30',
        loaded: () => { this._ready = true; },
      });
    });
  }

  identify(distinctId: string, properties?: Record<string, unknown>): void {
    if (!this._ready) return;
    posthog.identify(distinctId, properties);
  }

  reset(): void {
    if (!this._ready) return;
    posthog.reset();
  }
}
